import Vue from 'vue'
import {make} from 'vuex-pathify'

let initialState = {
    modal1: null,
    modal2: null,
    modal3: null,
    modal4: null,
    modal5: null,
    modal6: null
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
const mutations = make.mutations(state)

getters.activeModals = (state) => {
    let allActiveModals = []
    for (const modal in state) {
        if (state[modal] != null) {
            allActiveModals.push(state[modal])
        }
    }

    return allActiveModals
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
